import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { AlertTriangle } from 'lucide-react';
import { BowtieNode } from '../bowtie.types';

export const HazardNode: React.FC<{ data: BowtieNode }> = memo(({ data }) => {
  return (
    <div
      style={{
        background: '#fffbeb',
        border: '2px solid #f59e0b',
        borderRadius: '12px',
        padding: '10px 16px',
        width: '280px',
        boxSizing: 'border-box',
        boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.15)',
        textAlign: 'center',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', color: '#b45309', fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        <AlertTriangle size={14} />
        <span>HAZARD CONTEXT</span>
      </div>
      <div style={{ fontWeight: 600, fontSize: '13px', color: '#78350f', marginTop: '4px' }}>
        {data.label}
      </div>
      <Handle id="bottom" type="source" position={Position.Bottom} style={{ background: '#f59e0b', width: 8, height: 8 }} />
    </div>
  );
});
